import wootConstants from 'dashboard/constants/globals';

export const KANBAN_SORT_OPTIONS = [
  wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC,
  wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_ASC,
  wootConstants.SORT_BY_TYPE.CREATED_AT_DESC,
  wootConstants.SORT_BY_TYPE.CREATED_AT_ASC,
  wootConstants.SORT_BY_TYPE.PRIORITY_DESC,
  wootConstants.SORT_BY_TYPE.UNREAD,
  wootConstants.SORT_BY_TYPE.WAITING_SINCE_ASC,
];

export const KANBAN_DEFAULT_SORT =
  wootConstants.SORT_BY_TYPE.LAST_ACTIVITY_AT_DESC;

export const KANBAN_PAGE_SIZE = 25;
export const KANBAN_VISIBLE_LABELS = 2;

export const conversationMatchesQuery = (conversation, query) => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;

  const name = conversation.meta?.sender?.name || '';
  const lastNonActivity = conversation.last_non_activity_message?.content || '';
  const lastMessage = conversation.messages?.[0]?.content || '';
  const haystack = `${name} ${lastNonActivity} ${lastMessage} ${conversation.id}`;

  return haystack.toLowerCase().includes(needle);
};
